import { useGalleryOnPage } from '../../../components/Toolkit/Gallery/GalleryOnPage.hook';
import type { GalleryOnPageProps } from '../../../components/Toolkit/Gallery/GalleryOnPage.typed';
import { GalleryView } from '../../../components/Toolkit/Gallery/components/GalleryView/GalleryView';
import { GalleryModal } from '../../../components/Toolkit/Gallery/components/GalleryModal/GalleryModal';
import { useGalleryView } from '../../../components/Toolkit/Gallery/components/GalleryView/GalleryView.hook';

function GalleryOnPage(props: GalleryOnPageProps) {
  const {
    className,
    photo,
    photos,
    videoConfig,
    link360,
    link360Interior,
    mediaCount,
    title,
    youTubeVideoId,
    youTubeReviewVideoId,
    isYoutubeReviewOpen,
    setIsYoutubeReviewOpen,
    isDealer,
    trackingId,
    reportOnGalleryUsage,
    cdnUrl,
    isPreview,
    refreshTopAndSideDFPUnit,
    ...rest
  } = props;

  const displayImage =
    videoConfig?.customProperties?.thumbnail_url_0 || (photo && photo.medium);

  const { openGallery, closeGallery, isGalleryOpen } = useGalleryOnPage({
    reportOnGalleryUsage,
    displayImage,
  });

  // Todo move this into feature folder
  const {
    media,
    mediaPreview,
    photoCount,
    hasCarousel,
    mainGalleryMediaImage,
    mainGalleryMedia,
    galleryMedia,
    THUMBNAIL_360,
    getIndexGallery,
    handleOnMediaClick,
  } = useGalleryView({
    videoConfig,
    youTubeVideoId,
    youTubeReviewVideoId,
    link360,
    link360Interior,
    photos,
    isYoutubeReviewOpen,
  });

  return (
    <>
      <GalleryView
        title={title}
        photoCount={photoCount}
        media={mediaPreview}
        hasCarousel={hasCarousel}
        mainGalleryMediaImage={mainGalleryMediaImage}
        mainGalleryMedia={mainGalleryMedia}
        galleryMedia={galleryMedia}
        THUMBNAIL_360={THUMBNAIL_360}
        setIsYoutubeReviewOpen={setIsYoutubeReviewOpen}
        isDisabled={Boolean(isPreview)}
        openGallery={openGallery}
        onMediaClick={handleOnMediaClick}
      />
      {isGalleryOpen && (
        <GalleryModal
          isOpen={isGalleryOpen}
          askToClose={closeGallery}
          link360={link360}
          link360Interior={link360Interior}
          videoConfig={videoConfig}
          initialMediaIndex={getIndexGallery()}
          cdnUrl={cdnUrl}
          refreshTopAndSideDFPUnit={refreshTopAndSideDFPUnit}
          title={title}
          photos={photos}
          {...rest}
          media={media}
        />
      )}
    </>
  );
}

export { GalleryOnPage };
